'use strict';

angular.module('internal.vehicles')
    .directive('internalVehicleActions', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'vehicles/components/vehicle-actions/vehicle-actions.html',
            replace: true,
            controller: 'InternalActions'
        };
    }])
;